import React from 'react'
import { Route, Routes } from 'react-router-dom'
import OpenSidebarButton from '../Sidebar/Navigation/components/OpenSidebarButton';
import { OverviewLayout } from './Layouts/OverviewLayout'
import { ReactQueryDevtools } from 'react-query/devtools'


const Main = (props) => {
    return (
        <div className="flex flex-col h-full w-0 flex-1">
            <header>
                <OpenSidebarButton handleClick={props.handleClick} />
            </header>
            <Routes>
                <Route path='*' element={<OverviewLayout />} />
            </Routes>
            <ReactQueryDevtools position="bottom-right" />
        </div >

    )
}

export default Main
